<template>
  <div class="col mb-3">
      <div class="card mb-3  h-100">
          <img class="card-img-top" v-bind:src="person.headshot" v-bind:alt="person.name">
          <div class="card-body pb-0">
              <a v-bind:href="person.url" class="stretched-link">
                  <h5 class="card-title text-center filter-name">{{person.name}}</h5>
              </a>
              <h6 class="text-center filter-title" v-if="person.namedProfessorship">{{person.namedProfessorship}}</h6>
              <h6 class="text-center filter-title" v-else v-for="title in person.titles">{{title}}</h6>
              <h6 class="text-center filter-title" v-if="person.alternateTitles">{{person.alternateTitles}}</h6>
          </div>
          <div class="card-footer" style="background-color: #fff; border-top: none;">
              <h6 class="text-center filter-department" v-for="dept in person.department">
                  {{ dept }}
              </h6>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
    props: ['person'],
    data: function(){
      return {};
    }
  };
</script>
